import { toggleUnreadIndicator } from '@widgets/Comments/lib/polling/toggleUnreadIndicator';

import { ensureUnreadIndicatorStyles } from './ensureUnreadIndicatorStyles';

export const applyUnreadCommentsStateToDom = (unreadPositionGuids: string[]): void => {
    ensureUnreadIndicatorStyles();

    const unreadGuidSet = new Set(unreadPositionGuids.map((guid) => String(guid).trim()));

    document.querySelectorAll('[data-position-action="openCommentPopup"]').forEach((element) => {
        const positionElement = element.closest('.position');
        const positionGuid =
            element.getAttribute('data-position-guid') ||
            positionElement?.getAttribute('data-position-guid') ||
            positionElement?.getAttribute('data-excess-guid') ||
            positionElement?.getAttribute('data-position-id') ||
            '';

        toggleUnreadIndicator({
            triggerElement: element,
            shouldShow: unreadGuidSet.has(String(positionGuid).trim()),
            enableRemoveIndicator: true,
        });
    });
};
